///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_item_lists = abcsetup.new_item_lists || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_item_lists = {
    init: function() {
        let searchTerm = "";

        /**
         * Handle potential query string
         */
        $(document).ready(function() {
            const urlParams = new URLSearchParams(window.location.search);
            const list_name = urlParams.get('list_name');

            if (list_name) {
                $('#'+list_name).click();
            }
        });

        $(document).on('click', '.list-label', function(e) {
            let list_name = $(this).data('list');

            $('#main-heading').html($('.list-label-'+list_name).text());

            //clear list label styles
            $('.list-label').removeAttr('style');
            $('.list-label').css('cursor', 'pointer');
            
            //display the list elements
            $('.item-list').each(function(){ 
                if (! $(this).hasClass('d-none')) {
                    $(this).addClass('d-none');
                }
            });

            //display the list and style it
            $('.item-list-'+list_name).removeClass('d-none');
            $('.list-label-'+list_name).css({
                'color': 'white',
                'background-color': '#5ED579',
                'padding': '6px',
                'border-radius': '5px',
                'cursor': 'pointer'
            });

            //display the import list button
            if ($('#import_button').hasClass('d-none')) {
                $('#import_button').removeClass('d-none');
            }

            //display the export template button for a specific list
            if ($('#export_button').hasClass('d-none')) {
                $('#export_button').removeClass('d-none');
            }

            //hydrate the import list button with the list name data
            $('#import_button').attr('data-list-name', list_name);

            //hydrate the export button data and href
            $('#export_button').attr('data-list-name', list_name);
            $('#export_button').attr('href', '/new_item_lists/'+list_name+'/template');

            //Display the Add new button
            $('#add-new-list-item').removeClass('d-none');
            $('#add-new-list-item').attr('data-list-name', list_name);

            //handle list position if searching
            if (searchTerm != "") {
                search();
            }

            //Build the sortable
            if ($(this).data('seq') == true) {
                $('#order-help-message').text("Click and drag to reorder the list.");

                $('#sortable-'+list_name).sortable({
                    stop: function(event, ui) {
                        abcsetup.blockUI(true);
                        let list = [];
    
                        $('.' + list_name + '-item').each(function() {
                            list.push({
                                'id': $(this).data('id'),
                                'name': $(this).data('name')
                            });
                        });
    
                        axios.post('/new_item_lists/'+list_name+'/updateSeq', { 
                            items: list
                        })
                        .then(response => {
                            abcsetup.unblockUI();
                            if (response.data) {
                                let flash = $('#success-update-message');
                                flash.text(response.data.message).fadeIn();
                                setTimeout(() => {
                                    flash.fadeOut();
                                }, 2500);
                            }
                        })
                        .catch(error => {
                            abcsetup.unblockUI();
                            console.error(error);
                        });
                    }
                });
            } else {
                $('#order-help-message').text("");
            }
        });

        /**
         * Get and display the edit modal
         */
        $(document).on('click', '.edit-button', function(e) {
            let id = $(this).attr('data-id');
            let name = $(this).attr('data-name');
            let list_name = $(this).attr('data-list-name');
            
            $.get('/new_item_lists/edit', function(response) {
                if ($('body').find('#editListItemModal').length <= 0) {
                    $('body').append(response);
                }

                $('#new-list-id').val(id);
                $('#new-list-item-name').val(name);

                //set for querying purpouses
                $('#old-list-id-modal').val(id);
                $('#old-list-name-modal').val(name);
                $('#list-name-modal').val(list_name);
                
                $('#editListItemModal').modal('show');
            });
        });

        /**
         * Get and display the add modal
         */
        $(document).on('click', '#add-new-list-item', function(e) {
            let list_name = $(this).data('list-name');

            $.get('/new_item_lists/create', function(response) {
                if ($('body').find('#createNewListItemModal').length <= 0) {
                    $('body').append(response);
                }

                $('#create-item-list-list-name-modal').val(list_name);

                $('#new_list_item_id').val(null);
                $('#new_list_item_name').val(null);

                $('#createNewListItemModal').modal('show');
            });
        });

        /**
         * Update a list Item
         */
        $(document).on('click', '#update-list-item-button', function(e) {
            abcsetup.blockUI(true);

            let oldid = $('#old-list-id-modal').val();
            let oldname = $('#old-list-name-modal').val();
            let list_name = $('#list-name-modal').val();

            let newid = $('#new-list-id').val();
            let newname = $('#new-list-item-name').val();

            //clear the text
            $('#new-list-id').text("");
            $('#new-list-item-name').text("");

            axios.post('/new_item_lists/'+ list_name + '/update', {
                'old_id': oldid,
                'old_list_item_name': oldname,
                'new_id': newid,
                'new_list_item_name': newname
            })
            .then(response => {
                const data = response.data;

                if (data && data.listItem) {
                    const listItem = data.listItem;

                    //update the data attrs of the edit button
                    $(`.edit-button[data-id="${oldid}"][data-list-name="${list_name}"]`)
                        .attr('data-name', listItem.name)
                        .attr('data-id', listItem.id);
                       
                    //update the label text and the labels id.
                    $('#list-' + list_name + '-' + oldid).text(newid + ' - ' + newname);
                    $('#list-' + list_name + '-' + oldid).attr('id', 'list-' + list_name + '-' + newid);
                    
                    $('#close-edit-list-item-button').click();

                    abcsetup.unblockUI();
                    abcsetup.alerts.show('Success', response.data.message);
                }   
            })
            .catch(error => {
                abcsetup.unblockUI();
                abcsetup.alerts.show('Error', error.response.data.message);
                console.error(error);
            })
        });

        /**
         * Create a list item
         */
        $(document).on('click', '#save-new-list-item-button', function(e) {
            abcsetup.blockUI(true);

            let list_name = $('#create-item-list-list-name-modal').val();
            let id = $('#new_list_item_id').val();
            let name = $('#new_list_item_name').val();

            $('#new_list_item_id').text("");
            $('#new_list_item_name').text("");

            axios.post('/new_item_lists/store', {
                'id': id,
                'name': name,
                'list_name': list_name
            })
            .then(response => {
                if (response.data) {
                    //duplicate and append the new row TODO - make not shit
                    $('.' + list_name + '-item:last-child').after(
                        '<li class="'+list_name+'-item m-2" data-id="'+id+'" data-name="'+name+'">\
                            <div class="row">\
                                <div class="col-auto p-0">\
                                    <div class="btn-group">\
                                        <button\
                                            class="btn btn-sm btn-success border border-1 border-dark edit-button"\
                                            data-id="'+id+'"\
                                            data-name="'+name+'"\
                                            data-list-name="'+list_name+'"\
                                        >\
                                            <i class="fas fa-pencil"></i>\
                                        </button>\
                                        <button\
                                            class="btn btn-sm btn-danger border border-1 border-dark delete-button"\
                                            data-id="'+id+'"\
                                            data-name="'+name+'"\
                                            data-list-name="'+list_name+'"\
                                        >\
                                            <i class="fas fa-trash"></i>\
                                        </button>\
                                    </div>\
                                </div>\
                                <div class="col-md-6 px-0">\
                                    <h5\
                                        class="col-auto mt-1"\
                                        style="cursor: pointer;"\
                                        id="list-'+list_name+'-'+id+'"\
                                    >\
                                        '+id+' - '+name+'\
                                    </h5>\
                                </div>\
                            </div>\
                        </li>'
                    );
                }

                $('#' + list_name + '-count').text("(" + response.data.count + ")");
                $('#main-heading').text(response.data.main_heading);

                abcsetup.unblockUI();
                $('#create-item-list-item-close-button').click();
                abcsetup.alerts.show('Success', response.data.message);
            })
            .catch(error => {
                abcsetup.unblockUI();
                console.error(error);
            })
        });

        /**
         * Delete a list item
         */
        $(document).on('click', '.delete-button', function(e) {
            let item = $(this).parent().parent().parent().parent();
            let id = $(this).data('id');
            let list_name = $(this).data('list-name');

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to remove this item?', function (confirm) {
                if (confirm) {
                    abcsetup.blockUI(true);
            
                    axios.post('/new_item_lists/delete', {
                        'id': id,
                        'list_name': list_name
                    })
                    .then(response => {
                        abcsetup.unblockUI();

                        if (response.data) {
                            abcsetup.alerts.show('Success', response.data.message);
                            console.log(item);
                            item.remove();
                            $('#' + list_name + '-count').text("(" + response.data.count + ")");
                            $('#main-heading').text(response.data.main_heading);
                        }
                    })
                    .catch(error => {
                        abcsetup.unblockUI();
                        console.log(error);
                    });
                }
            });
        });

        /**
         * Get upload modal
         */
        $(document).on('click', '#import_button', function(e) {
            let list_name = $(this).data('list-name');

            $.get('/new_item_lists/upload/'+list_name, function(response) {
                console.log('response');
                if ($('body').find('#uploadListModal').length <= 0) {
                    $('body').append(response);
                }

                $('#uploadListModal').modal('show');
            });
        });

        $('#search-bar').on('keyup', function() {
            searchTerm = $(this).val().toLowerCase();
            search();
        });

        function search() {
            // Filter the list items based on search term
            $('.list-label').filter(function() {
                $(this).toggle($(this).text().toLowerCase().indexOf(searchTerm) > -1);
            });
        }
    },
}
